import { useTranslation } from "react-i18next";
import { Logo } from "packages/dsaui/src/components/icons";
import { cn } from "packages/dsaui/src/utils";
import routes from "routes";

const footerLinks = {
  privacy: "https://www.dsausa.org/privacy-policy/",
  support: routes.external.support,
  terms: "https://www.dsausa.org/terms-of-use/",
} as const;

const AuthLayout = ({ children }: React.PropsWithChildren) => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col overflow-x-hidden bg-gray-50">
      <div className="border-b border-gray-200 bg-white">
        <div className="flex items-start justify-between gap-4 px-4 py-3 sm:px-6 sm:py-3.5">
          <a
            className="inline-flex items-center text-inherit no-underline"
            href={routes.internal.base}
          >
            <Logo className="h-13.75 w-auto" />
          </a>
        </div>
      </div>
      <main className="flex-1 px-0 py-0 sm:px-4 sm:py-10">
        <div className="mx-auto w-full max-w-3xl overflow-hidden bg-white sm:border sm:border-gray-200 sm:shadow-xl">
          {children}
        </div>
      </main>
      <footer
        className={cn("border-t border-gray-200 bg-gray-50 px-4 py-6 sm:px-5 sm:py-8")}
      >
        <div className="flex flex-col items-center gap-4 text-center sm:gap-5">
          <p className="flex items-center gap-2 text-[18px] leading-7 text-gray-400">
            <Logo className="h-5 w-auto" />
            <span>DSA</span>
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[15px] text-gray-500 sm:gap-x-8">
            <a
              className="text-gray-500 no-underline transition-colors hover:text-gray-700"
              href={footerLinks.privacy}
              rel="noreferrer"
              target="_blank"
            >
              Privacy Policy
            </a>
            <a
              className="text-gray-500 no-underline transition-colors hover:text-gray-700"
              href={footerLinks.terms}
              rel="noreferrer"
              target="_blank"
            >
              Terms of Service
            </a>
          </div>
          <div className="flex flex-col items-center gap-2.5 sm:gap-3">
            <a
              className="text-[15px] text-gray-500 no-underline transition-colors hover:text-gray-700"
              href={footerLinks.support}
              rel="noreferrer"
              target="_blank"
            >
              {t("footer.support")}
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AuthLayout;
